import { createActions } from 'redux-actions';

import { CompanyUser, UserList } from '@models/User';
import { CreateUserOtpCodeParams } from '@apis/UserOtpCodeApi';

export type State = {
  companyUsers: CompanyUser[];
  frontlineUsers: UserList[];
};

export type OtpCodeRequestPayload = CreateUserOtpCodeParams;
export type StateUpdatePayload = Partial<State>;

export const {
  companyUsersFetch,
  frontlineUsersFetch,
  otpCodeRequest,
  stateUpdate,
} = createActions(
  'COMPANY_USERS_FETCH',
  'FRONTLINE_USERS_FETCH',
  'OTP_CODE_REQUEST',
  'STATE_UPDATE',
  {
    prefix: 'FEATURE_USER',
  },
);
